/* Free ring sizer: one per order (2026-09-28). Moved out of snippets/fe-sizer-limit.liquid by Round 1 decision #23
   (javascript-10, Wade 2026-10-13) so it is cached instead of re-sent in every page; how it works is described at the
   top of that snippet, which also keeps the sizer IDs and the note (passed here as data attributes). */
(function () {
  /* The sizer's variant and product IDs and the product-page note come from this script tag's data attributes
     (snippets/fe-sizer-limit.liquid). */
  var me = document.currentScript;
  if (!me) return;
  var VID = Number(me.getAttribute('data-variant'));
  var PID = Number(me.getAttribute('data-product'));
  var NOTE = me.getAttribute('data-note') || '';
  if (!VID) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cart = null;      /* last known cart.js */
  var fixing = false;   /* re-entrancy guard for cap() */
  if (!window.fetch || !window.Promise) return;

  function sizerLines(c) {
    return ((c && c.items) || []).filter(function (it) { return Number(it.variant_id) === VID; });
  }
  function inCart(c) { return sizerLines(c).length > 0; }
  function isCartPage() {
    var st = (window.themeVariables && window.themeVariables.settings) || {};
    return st.pageType === 'cart' || /^\/cart\/?$/.test(window.location.pathname.replace(root.replace(/\/$/, ''), ''));
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }
  function bundledSections() {
    var s = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: s } }));
    return s;
  }
  function closeSizerModals() {
    var nav = document.getElementById('feNavSizer');
    if (nav && !nav.hidden) { var c1 = nav.querySelector('[data-fns-close]'); if (c1) c1.click(); }
    var pdp = document.getElementById('rsModal');
    if (pdp && !pdp.hidden) { var c2 = pdp.querySelector('[data-rs-close]'); if (c2) c2.click(); }
  }

  /* Open the drawer on the cart as it stands (no add). Same cart:change contract the theme's own
     product-form uses, so cart-drawer replaces its content and, because baseEvent is variant:add, opens. */
  function showDrawer(c) {
    var sections = bundledSections();
    var html = sections.length
      ? fetch(root + '?sections=' + encodeURIComponent(sections.join(','))).then(function (r) { return r.json(); }).catch(function () { return {}; })
      : Promise.resolve({});
    return html.then(function (h) {
      c.sections = h || {};
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: c } }));
    });
  }

  /* Add exactly one sizer (used when a swallowed click turns out to have a stale cache, e.g. the sizer
     was removed in another tab). Same flow as the modal buttons; falls back to the GET permalink. */
  function addOne() {
    var sections = bundledSections();
    var fd = new FormData();
    fd.set('id', String(VID)); fd.set('quantity', '1');
    fd.set('sections', sections.join(',')); fd.set('sections_url', root + 'variants/' + VID);
    return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'add failed'); return j; }); })
      .then(function (added) {
        if (isCartPage()) { window.location.reload(); return; }
        return refreshCart().then(function (c) {
          c.sections = added.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: c } }));
        });
      })
      .catch(function () { window.location.href = root + 'cart/add?id=' + VID + '&quantity=1'; });
  }

  /* Step 2: bring any sizer total above one back to one. */
  function cap(c) {
    if (fixing) return Promise.resolve(false);
    var lines = sizerLines(c);
    var total = lines.reduce(function (s, l) { return s + (Number(l.quantity) || 0); }, 0);
    if (total <= 1) return Promise.resolve(false);
    fixing = true;
    var updates = {};
    lines.forEach(function (l, i) { updates[l.key] = i === 0 ? 1 : 0; });
    var sections = bundledSections();
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates, sections: sections.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.items) return false;
        cart = j;
        if (isCartPage()) { window.location.reload(); return true; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: j } }));
        return true;
      })
      .catch(function () { return false; })
      .then(function (r) { fixing = false; return r; });
  }

  /* Step 1: swallow a second add. Capture phase so this runs before the button's own handler,
     the theme's product-form and any app that hooks the form. */
  function sizerButton(el) {
    var b = el && el.closest ? el.closest('[data-fns-add], [data-rs-mail-add]') : null;
    if (!b) return null;
    var v = b.getAttribute('data-fns-add') || b.getAttribute('data-rs-mail-add');
    return Number(v) === VID ? b : null;
  }
  function sizerForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;
    var id = null;
    try { id = new FormData(form).get('id'); } catch (e) {}
    if (id == null) { var inp = form.querySelector('input[name="id"]'); id = inp && inp.value; }
    return Number(id) === VID;
  }
  function swallow(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    closeSizerModals();
    /* Re-check the live cart before deciding: stale cache -> add one; really in cart -> just show it. */
    refreshCart().then(function (c) {
      if (!inCart(c)) return addOne();
      if (isCartPage()) return cap(c);
      return showDrawer(c);
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (!inCart(cart)) return;
    if (sizerButton(e.target)) swallow(e);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!inCart(cart)) return;
    if (sizerForm(e.target)) swallow(e);
  }, true);

  /* Keep the local cart fresh and re-check after every change. */
  document.addEventListener('cart:change', function (e) {
    var c = e.detail && e.detail.cart;
    if (!c || !c.items) return;
    cart = c;
    cap(c);
  });
  document.addEventListener('cart:refresh', function () { refreshCart().then(cap); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().then(cap); });
  /* PageSpeed #100 (Wade 2026-10-14, built 2026-10-29): reuse the /cart.js request Prestige's theme.js already makes at startup (its
     module exports fetchCart: a promise, or the cart object after a cart:change) instead of a second request on every page. The
     dynamic import resolves through the layout's importmap ("theme"); if anything about it fails, the old request runs. */
  var viaTheme = null;
  try { viaTheme = new Function('return import("theme")'); } catch (e) { viaTheme = null; }
  (viaTheme ? viaTheme().then(function (m) { return Promise.resolve(m.fetchCart); }) : Promise.reject(new Error('no import')))
    .then(function (c) { if (!c || !c.items) throw new Error('no cart'); cart = c; return cap(c); })
    .catch(function () { return refreshCart().then(cap).catch(function () {}); });

  /* Step 3: the sizer's own product page. */
  function pdpNote() {
    var sel = document.querySelector('product-rerender[id^="product-info-' + PID + '-"] .quantity-selector');
    if (!sel || sel.parentNode.querySelector('.fe-sizer-one')) return;
    var p = document.createElement('p');
    p.className = 'fe-sizer-one';
    p.textContent = NOTE;
    sel.parentNode.insertBefore(p, sel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdpNote); else pdpNote();
})();
